/**
 * The alias to this folder is marketing/playcards
 *
 * Consider using this file as entry point to the container.
 * Ideally, you should import, bind and register all req  required modules or components from here
 */
import PlayCardFormMixin from './_mixins/buy-playcard-form'
import PlayCardReloadFormMixin from './_mixins/reload-playcard-form'
import PlayCardListMixin from './_mixins/playcard-list'

import LocationService from './services/location'
import ProductService from './services/product'
import SettingsService from './services/settings'

import components from './components'

export default {
  components,
  'mixins': {PlayCardFormMixin, PlayCardListMixin, PlayCardReloadFormMixin},
  'vuex': {},
  'services': {LocationService, ProductService, SettingsService},

}

